import { cn } from "@anthra/ui/cn"

/** Store brand marks. Material Symbols never ships brand logos. */
export function AppleMark({ className = "h-5 w-5" }: { className?: string }) {
	return (
		<img
			src="/images/app-store.png"
			alt=""
			className={cn(className)}
		/>
	)
}

export function PlayMark({ className = "h-5 w-5" }: { className?: string }) {
	return (
		<img
			src="/images/google-play-store-icon.svg"
			alt=""
			className={cn(className)}
		/>
	)
}
